import { useState } from "react";
import { EyeOff } from "lucide-react";
import { redirectBaseUrl } from "@/lib/short-links";

// "Nao contar minhas visitas". Decisao: o Worker de redirect grava um cookie
// PRIMARIO no proprio dominio dele (r.lucralink.com.br) quando o dono abre
// /contagem/desligar numa aba (navegacao de topo). Nada de cookie de
// terceiros, pixel ou identificador: o cookie so diz "nao grave cliques deste
// navegador". O painel guarda a escolha so para exibir o estado do botao.
export const OPT_OUT_STORAGE_KEY = "lucralink:nao-contar-visitas";

function readStored(): boolean {
  try {
    return window.localStorage.getItem(OPT_OUT_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

function writeStored(value: boolean): void {
  try {
    window.localStorage.setItem(OPT_OUT_STORAGE_KEY, value ? "1" : "0");
  } catch {
    // Sem localStorage (aba anonima): o cookie do Worker continua valendo,
    // so o estado do botao nao fica lembrado neste navegador.
  }
}

export function OptOutToggle(): JSX.Element {
  const [enabled, setEnabled] = useState<boolean>(readStored);

  function toggle(): void {
    const next = !enabled;
    const path = next ? "/contagem/desligar" : "/contagem/ligar";
    window.open(`${redirectBaseUrl()}${path}`, "_blank", "noopener,noreferrer");
    writeStored(next);
    setEnabled(next);
  }

  return (
    <label className="relative flex items-center gap-2 text-xs text-muted-foreground cursor-pointer select-none" title="Abre uma aba que marca este navegador para não entrar nas métricas. Sem cookies de terceiros.">
      <input type="checkbox" role="switch" checked={enabled} onChange={toggle} className="peer sr-only" />
      <span
        aria-hidden="true"
        className="relative inline-flex h-4 w-7 items-center rounded-full bg-[hsl(var(--border-strong))] transition-colors peer-checked:bg-[hsl(var(--primary))] peer-focus-visible:ring-2 peer-focus-visible:ring-[hsl(var(--ring))] after:absolute after:left-0.5 after:h-3 after:w-3 after:rounded-full after:bg-white after:transition-transform peer-checked:after:translate-x-3"
      />
      <EyeOff size={12} aria-hidden="true" />
      Não contar minhas visitas
    </label>
  );
}
